import { apiClient } from './axios';

async function addReport(body) {
  try {
    const report = await apiClient.post('/report', body);
    return report;
  } catch {
    return null;
  }
}

async function getReport(id) {
  try {
    const report = await apiClient.get(`/report/${id}`);
    return report;
  } catch {
    return null;
  }
}

async function getReportByStudent(studentId, coursePlanId) {
  try {
    const report = await apiClient.get(`report/student/${studentId}/${coursePlanId}`);
    return report;
  } catch {
    return null;
  }
}

async function updateReport(reportId, body) {
  try {
    const report = await apiClient.put(`report/${reportId}`, body);
    return report;
  } catch {
    return null;
  }
}

async function addCustomPresence(reportId, customPresence) {
  try {
    const report = await apiClient.put(`report/customPresence/${reportId}/${customPresence}`);
    return report;
  } catch {
    return null;
  }
}

async function updateCustomPresence(reportId, customPresence) {
  try {
    const report = await apiClient.put(`report/updateCustomPresence/${reportId}/${customPresence}`);
    return report;
  } catch {
    return null;
  }
}

async function deleteCustomPresence(reportId, customPresence) {
  try {
    const report = await apiClient.put(`report/deleteCustomPresence/${reportId}/${customPresence}`);
    return report;
  } catch {
    return null;
  }
}

const reportServices = {
  addReport,
  getReport,
  getReportByStudent,
  updateReport,
  addCustomPresence,
  updateCustomPresence,
  deleteCustomPresence,
};

export default reportServices;
